import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import {
  HomeContextImport,
  HomeContextProvider,
} from "../../provider/home/HomeContextProvider";
import EmailBody from "./widget/EmailList";
import Div from "../../widget/common/ui/Div";
import SessionStorage from "../../service/storage/SessionStorage";
import StorageKeys from "../../const/StorageKeys";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import BranchLogoName from "../../widget/screens/home/BranchLogoName";
import Center from "../../widget/common/ui/Center";
import { SpacingHeight } from "../../widget/common/ui/Spacing";
import Loader from "../../widget/common/ui/Loader";
import { AppLink } from "../../model/home/BranchInfoModel";
import {
  HomeGuestUserContextImport,
  HomeGuestUserContextProvider,
} from "../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";
import CacheStorage from "../../service/storage/CacheStorage";

const EmailContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  return (
    <HomeContextProvider>
      <HomeGuestUserContextProvider>
        <EmailContentMain type={type} isModal={isModal} />
      </HomeGuestUserContextProvider>
    </HomeContextProvider>
  );
};

const EmailContentMain = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  const guestStatus: string =
    SessionStorage.getValue(StorageKeys.guest_status) || "0";

  //const { getBranchDetail, branchDetail } = HomeContextImport();

  const homeContext = HomeContextImport();
  const homeGuestContext = HomeGuestUserContextImport();

  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [emailList, setEmailList] = useState<AppLink[] | undefined>(undefined);

  const getBranchInfo = () => {
    if (guestStatus === "1") {
      homeGuestContext.getBranchDetail();
    } else {
      homeContext.getBranchDetail();
    }
  };

  const initData = () => {
    if (!isModal) {
      getBranchInfo();
    }
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    if (
      UtilityHelper.isEmpty(branchNameSession) ||
      UtilityHelper.isEmpty(branchLogoSession)
    ) {
      getBranchInfo();
    } else {
      setBranchName(branchNameSession);
      setBranchLogo(branchLogoSession);
    }
  };

  useEffect(() => {
    initData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (homeGuestContext.branchDetail != null) {
      setBranchName(homeGuestContext.branchDetail?.title!);
      setBranchLogo(homeGuestContext.branchDetail?.branch_logo_url!);
      setEmailList(homeGuestContext.branchDetail?.email_list!);
    }
    if (homeContext.branchDetail != null) {
      setBranchName(homeContext.branchDetail?.title!);
      setBranchLogo(homeContext.branchDetail?.branch_logo_url!);
      setEmailList(homeContext.branchDetail?.email_list!);
    }
  }, [homeContext.branchDetail, homeGuestContext.branchDetail]);

  /* if (guestStatus === "1") {
    useEffect(() => {
      if (homeGuestContext.branchDetail != null) {
        setBranchName(homeGuestContext.branchDetail?.title!);
        setBranchLogo(homeGuestContext.branchDetail?.branch_logo_url!);
        setEmailList(homeGuestContext.branchDetail?.email_list!);
      }
    }, [homeGuestContext.branchDetail]);
  } else {
    useEffect(() => {
      if (homeContext.branchDetail != null) {
        setBranchName(homeContext.branchDetail?.title!);
        setBranchLogo(homeContext.branchDetail?.branch_logo_url!);
        setEmailList(homeContext.branchDetail?.email_list!);
      }
    }, [homeContext.branchDetail]);
  } */

  return (
    <Div className={`${!isModal && "py-5 h-100"}`}>
      <>
        {UtilityHelper.isEmpty(branchName) ? (
          <Center className="h-100">{Loader.normal()}</Center>
        ) : (
          !isModal && (
            <>
              <BranchLogoName name={branchName} logo={branchLogo} type={type} />
              <SpacingHeight value={40} />
            </>
          )
        )}
      </>

      {UtilityHelper.isNotEmpty(branchName) && (
        <EmailBody emailList={emailList} isModal={isModal} />
      )}
    </Div>
  );
};

export default EmailContent;
